<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="form.moneda"
                :items="monedasOpciones"
                label="Moneda"
                required
                outlined
                dense
                hide-details
                clearable></v-select>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="unidadNegocioSeleccionadaId"
                :items="unidadesNegocios"
                item-text="nombre"
                item-value="id"
                label="Unidad de Negocio"
                required
                outlined
                dense
                hide-details
                clearable
                @change="
                  () => {
                    form.cantidad = 1;
                    form.categoriaId = null;
                  }
                "></v-select>
            </v-col>

            <v-col cols="12" lg="4">
              <v-text-field
                v-model="form.cantidad"
                label="Cantidad"
                type="number"
                min="1"
                step="1"
                :disabled="unidadesNegocios.length === 0 || !unidadNegocioSeleccionadaId"
                required
                outlined
                dense
                hide-details
                clearable></v-text-field>
            </v-col>

            <v-col cols="12" lg="8">
              <v-select
                v-model="form.categoriaId"
                :items="categoriasFiltradas"
                item-text="nombre"
                item-value="id"
                label="Categorías"
                :disabled="unidadesNegocios.length === 0 || !unidadNegocioSeleccionadaId"
                required
                outlined
                dense
                hide-details
                clearable>
                <template #item="{ item }">
                  <v-list>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ unidadesNegocios.find((unidadNegocio) => unidadNegocio.id == item.unidadNegocioId)?.nombre }}
                    </v-list-item-subtitle>
                  </v-list>
                </template>
              </v-select>

              <small v-for="error in errores.categoriaId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="4">
              <v-text-field
                v-model="form.equivalencia"
                label="Equivalencia"
                type="number"
                min="0"
                step="1"
                required
                outlined
                dense
                hide-details
                clearable></v-text-field>

              <small v-for="error in errores.equivalencia" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12" lg="8">
              <v-select
                v-model="form.categoriaEquivalenteId"
                :items="categoriasBasesEquivalentes"
                item-text="nombre"
                item-value="id"
                label="Categoría Equivalente"
                required
                outlined
                dense
                hide-details
                readonly></v-select>

              <small v-for="error in errores.categoriaEquivalenteId" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="form.nombrePlanCobroPrograma"
                :items="nombresPlanesCobroPrograma"
                :search-input.sync="busquedaPlanCobroPrograma"
                :loading="cargandoPlanesCobroPrograma"
                label="Nombre Plan Cobro Programa (opcional)"
                no-filter
                outlined
                dense
                hide-details
                clearable></v-autocomplete>

              <small v-for="error in errores.nombrePlanCobroPrograma" :key="error" class="d-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" :disabled="guardando" :loading="guardando" text @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../../mixins/modal-form.mixin';
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import CategoriasService from '../../services/categorias.service';
import { ACCIONES, MONEDAS_OPCIONES } from '../../utils/constantes';
import CategoriasEquivalentesService from '../../services/categorias-equivalentes.service';
import unidadesNegociosService from '../../services/unidades-negocios.service';
import planCobrosProgramaService from '../../services/plan-cobros-programa.service';

export default {
  name: 'ModalFormularioCategoriasEquivalentes',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    institucionId: {
      type: Number,
      required: true,
    },
  },
  watch: {
    'form.moneda': function () {
      this.errores.moneda = [];
    },
    'form.categoriaId': function () {
      this.errores.categoriaId = [];
    },
    'form.categoriaEquivalenteId': function () {
      this.errores.categoriaEquivalenteId = [];
    },
    'form.cantidad': function () {
      this.errores.cantidad = [];
    },
    'form.equivalencia': function () {
      this.errores.equivalencia = [];
    },
    'form.nombrePlanCobroPrograma': function () {
      this.errores.nombrePlanCobroPrograma = [];
    },
    busquedaPlanCobroPrograma() {
      this.buscarPlanesCobroPrograma();
    },
  },
  computed: {
    categoriasFiltradas() {
      return this.categorias.filter((categoria) => categoria.unidadNegocioId == this.unidadNegocioSeleccionadaId);
    },
  },
  data() {
    return {
      categorias: [],
      categoriasBasesEquivalentes: [],
      unidadesNegocios: [],
      unidadNegocioSeleccionadaId: null,
      monedasOpciones: MONEDAS_OPCIONES,
      nombresPlanesCobroPrograma: [],
      busquedaPlanCobroPrograma: null,
      retardoBusquedaPlanCobroPrograma: null,
      cargandoPlanesCobroPrograma: false,
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      this.unidadNegocioSeleccionadaId = null;
      this.nombresPlanesCobroPrograma = [];
      this.busquedaPlanCobroPrograma = null;

      return {
        id: null,
        institucionId: this.institucionId,
        institucion: null,
        moneda: null,
        categoriaId: null,
        categoria: null,
        categoriaEquivalenteId: null,
        categoriaEquivalente: null,
        cantidad: 1,
        equivalencia: 1,
        nombrePlanCobroPrograma: null,
      };
    },
    generarObjetoFormEditar(data) {
      this.unidadNegocioSeleccionadaId = data.categoria.unidadNegocioId;
      this.nombresPlanesCobroPrograma = data.nombrePlanCobroPrograma ? [data.nombrePlanCobroPrograma] : [];
      this.busquedaPlanCobroPrograma = null;

      return {
        id: data.id,
        institucionId: data.institucionId,
        institucion: data.institucion,
        moneda: data.moneda,
        categoriaId: data.categoriaId,
        categoria: data.categoria,
        categoriaEquivalenteId: data.categoriaEquivalenteId,
        categoriaEquivalente: data.categoriaEquivalente,
        cantidad: data.cantidad,
        equivalencia: data.equivalencia,
        nombrePlanCobroPrograma: data.nombrePlanCobroPrograma || null,
      };
    },
    abrir(accion, data = []) {
      Promise.all([
        this.obtenerUnidadesNegocios(),
        this.obtenerCategorias(),
        this.obtenerCategoriaBaseEquivalente(),
      ]).then(() => {
        this.abrirMixin(accion, data);

        if (accion === ACCIONES.REGISTRAR && this.categoriasBasesEquivalentes.length > 0) {
          this.form.categoriaEquivalenteId = this.categoriasBasesEquivalentes[0]?.id;
          this.form.categoriaEquivalente = this.categoriasBasesEquivalentes[0];
        }
      });
    },
    cerrar() {
      this.cerrarMixin();
    },
    async obtenerCategorias() {
      await this.findAllMixin(
        CategoriasService.findAll,
        null,
        'CATEGORÍAS',
        () => {
          this.categorias = [];
        },
        null,
        (datos) => {
          this.categorias = datos;
        },
        () => {
          this.categorias = [];
        },
      );
    },
    async obtenerCategoriaBaseEquivalente() {
      await this.findAllMixin(
        CategoriasService.findCategoriaBaseEquivalente,
        null,
        'CATEGORÍA BASE EQUIVALENTE',
        () => {
          this.categoriasBasesEquivalentes = [];
        },
        null,
        (datos) => {
          this.categoriasBasesEquivalentes = [datos];
        },
        () => {
          this.categoriasBasesEquivalentes = [];
        },
      );
    },
    async obtenerUnidadesNegocios() {
      await this.findAllMixin(
        unidadesNegociosService.findAll,
        null,
        'UNIDADES NEGOCIOS',
        () => {
          this.unidadesNegocios = [];
        },
        null,
        (datos) => {
          this.unidadesNegocios = datos;
        },
        () => {
          this.unidadesNegocios = [];
        },
      );
    },
    async obtenerPlanesCobroPrograma() {
      this.cargandoPlanesCobroPrograma = true;

      const params = {
        busqueda: this.busquedaPlanCobroPrograma,
        pagina: 1,
        itemsPorPagina: 50,
      };

      try {
        const response = await planCobrosProgramaService.findAllNombres({ params });
        const { datos = [] } = response?.data || {};

        this.nombresPlanesCobroPrograma = datos;
      } catch (error) {
        window.console.log(error);

        this.nombresPlanesCobroPrograma = [];
      } finally {
        this.cargandoPlanesCobroPrograma = false;
      }
    },
    buscarPlanesCobroPrograma() {
      if (!this.busquedaPlanCobroPrograma || this.form.nombrePlanCobroPrograma === this.busquedaPlanCobroPrograma) {
        return;
      }

      if (this.retardoBusquedaPlanCobroPrograma) {
        clearTimeout(this.retardoBusquedaPlanCobroPrograma);
      }

      this.retardoBusquedaPlanCobroPrograma = setTimeout(() => {
        this.obtenerPlanesCobroPrograma();
      }, 500);
    },
    async guardar() {
      if (this.guardando) {
        return;
      }

      const accion = this.form?.id ? ACCIONES.EDITAR : ACCIONES.REGISTRAR;
      const fnServicio = this.form?.id ? CategoriasEquivalentesService.update : CategoriasEquivalentesService.create;

      await this.saveMixin(
        accion,
        fnServicio,
        {
          ...this.form,
          nombrePlanCobroPrograma: this.form.nombrePlanCobroPrograma || null,
        },
        null,
        'CATEGORÍA EQUIVALENTE',
        () => {
          this.guardando = true;
          this.errores = [];
        },
        () => {
          this.guardando = false;
        },
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          if (typeof errores === 'object') {
            this.errores = errores;
          }
        },
      );
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>